<template>
  <div class="page" v-cloak>
    <navbar></navbar>

    <!-- 顶部状态-->
    <div class="header-block">
      <div class="header-tips">
        <div class="header-tips-title">{{ details.order_status_name }}</div>
        <!-- <div class="header-tips-desc"> 如果未能在30分钟内付款，订单将要取消。</div>
        <div class="header-tips-desc">请稍等，我们已经开始打包尽快给您发出。</div>
        <div class="header-tips-desc">如果收到商品有问题请及时联系我们。</div> -->
        <div class="header-tips-desc">感谢您的支持，您的支持是我们最大的动力。</div>
        <!-- <div class="header-tips-desc">订单已经取消，如果你有什么问题请联系我们。</div> -->
      </div>

    </div>

    <!-- 收货地址 -->
    <div class="mation-block" v-if="details && details.address">
      <div class="address-l">收货地址</div>
      <div class="line"></div>
      <div class="mation-info">
        <div class="mation-name">
          {{ details.address.contacts }}
        </div>
        <div class="mation-time">{{ details.address.phone }}</div>
        <div class="mation-address">
          {{ details.address.full_address }}
        </div>
      </div>
    </div>

    <!-- 钱款状态 -->
    <!-- <div class="order-detail">
      <div class="order-detail-tips">钱款状态</div>
      <div class="total_t">商家已经同意退款，钱款原路返回支付账号，1-7个
        工作日到账，如没有到账请 <span @click="makePhoneCall()">联系我们</span> </div>
    </div> -->

    <div class="goods-block">
      <div v-for="(item, index) in details.goods" :key="index">

        <div class="order-info-block">
          <img class="img" :src="item.goods_pic" />

          <div class="info-block">
            <div class="name van-multi-ellipsis--l2">{{ item.goods_name }}</div>
            <!-- <view class="desc">{{item.productImage}}</view> -->
            <span class="udc">{{ item.sku }}</span>

            <div class="price-block">
              <div class="price-tips">销售价</div>
              <div class="price">
                <span>￥{{ item.goods_price }}</span>
                <span class="num"> 共 {{item.goods_num}}件</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="total-block btb">
          <div class="total-left">
            <span class="total-tips">共{{item.quantity}}件</span>
            <span>小计</span>
          </div>
          <div class="total-right">¥{{ item.payAmount }}</div>
        </div> -->

        <!-- 物流信息 -->
        <div class="delivery-block" v-if="item.deliveryCode">
          <div class="delivery-express-l">物流信息</div>
          <div class="delivery-line"></div>
          <div class="delivery-info">
            <div class="delivery-name">快递公司:{{ item.deliveryCompany }}</div>
            <div class="delivery-time">
              快递单号:
              <span id="copyExpress">{{ item.deliveryCode }}</span>
              <span class="copy" data-clipboard-target="#copyExpress">复制单号</span>
            </div>

          </div>
        </div>

      </div>

      <div class="total-block">
        <div class="total-left">
          <span class="total-tips">商品金额</span>
        </div>
        <div class="total-right">￥{{ details.goods_total }}</div>
      </div>

      <div class="total-block">
        <div class="total-left">
          <span class="total-tips">运费</span>
        </div>
        <div class="total-right">+￥{{details.freight}}</div>
      </div>

      <div class="total-block" v-if="details.coupon_price > 0">
        <div class="total-left">
          <span class="total-tips">优惠券</span>
        </div>
        <div class="total-right">-￥{{details.coupon_price}}</div>
      </div>

      <div class="total-block" v-if="details.user_money > 0">
        <div class="total-left">
          <span class="total-tips">钱包</span>
        </div>
        <div class="total-right">-￥{{details.user_money}}</div>
      </div>

      <div class="total-block" v-if="details.bj_user_money > 0">
        <div class="total-left">
          <span class="total-tips">洗车钱包</span>
        </div>
        <div class="total-right">-￥{{details.bj_user_money}}</div>
      </div>

      <div class="total-block" v-if="details.integral_price > 0">
        <div class="total-left">
          <span class="total-tips">积分</span>
        </div>
        <div class="total-right">-￥{{details.integral_price}}</div>
      </div>

      <div class="total-block">
        <div class="total-left">
          <span class="total-tips">订单总金额</span>
        </div>
        <div class="total-right">￥{{ details.total_amount }}</div>
      </div>

      <div class="total-block">
        <div class="total-left">
          <span></span>
          <span>实付金额</span>
        </div>
        <div class="total-price">¥{{ details.order_amount }}</div>
      </div>

    </div>

    <!-- 底部详情 -->
    <div class="order-detail">
      <div class="order-detail-tips">订单信息</div>
      <div class="total-block">
        <div class="total-left">
          <span class="fz" data-clipboard-target="#copy">复制编号</span>
          <span>订单编号</span>
        </div>
        <div class="total-right" id="copy">{{ details.order_sn }}</div>
      </div>

      <div class="total-block" v-if="details.created_time">
        <div class="total-left">
          <span></span>
          <span>创建时间</span>
        </div>
        <div class="total-right">{{ details.created_time }}</div>
      </div>

      <div class="total-block" v-if="details.pay_time">
        <div class="total-left">
          <span></span>
          <span>付款时间</span>
        </div>
        <div class="total-right">{{ details.pay_time }}</div>
      </div>

      <div class="total-block" v-if="details.pay_name">
        <div class="total-left">
          <span></span>
          <span>支付方式</span>
        </div>
        <div class="total-right">{{ details.pay_name }}</div>
      </div>

      <div class="total-block" v-if="details.cancel_time">
        <div class="total-left">
          <span></span>
          <span>取消时间</span>
        </div>
        <div class="total-right">{{ details.cancel_time }}</div>
      </div>

      <div class="total-block">
        <div class="total-left">
          <span></span>
          <span>发货方式</span>
        </div>
        <div class="total-right">{{ details.shipping_name }}</div>
      </div>

      <div class="total-block" v-if="details.shipping_time">
        <div class="total-left">
          <span></span>
          <span>发货时间</span>
        </div>
        <div class="total-right">{{ details.shipping_time }}</div>
      </div>

      <div class="total-block" v-if="details.confirm_time">
        <div class="total-left">
          <span></span>
          <span>完成时间</span>
        </div>
        <div class="total-right">{{ details.confirm_time }}</div>
      </div>

      <div class="total-block" v-if="details.user_note">
        <div class="total-left">
          <span></span>
          <span>用户留言</span>
        </div>
        <div class="total-right">{{ details.user_note }}</div>
      </div>

    </div>

    <!-- 顶部详情 -->
    <!-- <div class="order-detail">
      <div class="order-detail-tips">拒绝原因</div>
      <div class="total_t">快递停在上海一个月了，没有收到货。</div>
    </div> -->

    <!-- 底部按钮 -->
    <div class="foot-order-btn-block">
      <!-- //4：已取消，-1：未支付，1：待发货，2：待收货 -->

      <div class="btn btns" v-if="details.order_status == -1 ||  details.order_status == '-1'" @click="cancelOrder()">取消订单</div>
      <div class="btn btnf" v-if="details.order_status == -1 ||  details.order_status == '-1'" @click="goPayresult()">立即支付</div>
      <!-- <div class="btn" @click="goPage({name:'order-after',query:{id:details.state}})">申请售后</div> -->
      <!-- <div class="btn" @click="goPage({name:'order-after-step',query:{id:details.state}})">售后进度</div> -->
      <div class="btn btnf" v-if="details.shipping_name != '自取'&&details.shipping&&details.shipping.length > 0" @click="goExpressPage(details)">查看物流</div>
      <!-- <div class="btn btnf" @click="goPage({name:'comment-in',query:{id:details.state}})">评价订单</div> -->
      <!-- <div class="btn btnf" v-if="details.order_status  == 1 && time == 0" @click="remind">提醒发货</div>
      <div class="btn btnf op" v-if="details.order_status == 1 && time > 0">{{ time }}</div> -->

      <div class="btn btns click" v-if="details.order_status == 4" @click="delete_order()">删除订单</div>

      <div class="btn" @click="makePhoneCall">联系我们</div>

    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import ClipboardJS from "clipboard";
import navbar from "@/components/navbar/navbar.vue";
export default {
  name: "OrderDetails",
  components: { navbar },
  props: {},
  data() {
    return {
      order_sn: this.$route.query.order_sn,
      isType: "",
      time: 0,
      currentTime: 20,

      details: {
        // order_status: "",
        // order_status_name: "状态",
        // order_sn: "",
        // address: {
        //   full_address: "",
        //   post_code: "",
        //   contacts: "",
        //   phone: "",
        // },
        // created_time: "创建日期",
        // pay_time: "支付日期",
        // pay_name: "支付方式",
        // shipping_time: "发货日期",
        // confirm_time: "确认收货日期",
        // cancel_time: "取消日期",
        // freight: "运费",
        // coupon_price: "优惠券抵扣金额",
        // goods_total: "商品总金额",
        // order_amount: "应付金额（线上支付）",
        // total_amount: "订单总金额",
        // user_money: "使用钱包支付金额",
        // bj_user_money: "使用洗车钱包金额",
        // integral_price: "积分抵扣金额",
        // user_note: "用户留言",
        // goods: [
        //   {
        //     goods_id: "",
        //     goods_name: "",
        //     goods_pic: "",
        //     goods_num: "",
        //     goods_price: "",
        //     market_price: "",
        //   },
        // ],
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$toast.allowMultiple();
    this.getDetails(); //获取订单详情
    this.fz();
    this.copy();
  },
  methods: {
    getDetails(e) {
      let _this = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let data = {
        order_sn: this.order_sn,
      };
      this.$post("/api/user_order_detail", data, data).then((res) => {
        // console.log(res);
        this.$toast.clear(); //关闭弹窗
        if (res.data.code == 0) {
          // console.log(res.data);
          this.details = res.data.data; 
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
    // 复制快递单号
    copy() {
      let ClipboardJSObj = new ClipboardJS(".copy"); //className中有copyEle的元素
      //定义复制成功回调
      ClipboardJSObj.on("success", function (e) {
        alert("复制成功");
        e.clearSelection();
      });
      //定义复制失败回调
      ClipboardJSObj.on("error", function (e) {
        // alert('复制失败')
      });
    },
    // 复制订单号
    fz() {
      let ClipboardJSObj = new ClipboardJS(".fz"); //className中有copyEle的元素
      //定义复制成功回调
      ClipboardJSObj.on("success", function (e) {
        alert("复制成功");
        e.clearSelection();
      });
      //定义复制失败回调
      ClipboardJSObj.on("error", function (e) {
        // alert('复制失败')
      });
    },
    //, 提醒发货
    remind() {
      var that = this;
      var currentTime = that.currentTime;
      this.$toast({
        message: "已提醒商家~",
      });
      that.time = currentTime;

      let interval = setInterval(function () {
        that.time = currentTime - 1;
        currentTime--;
        if (currentTime <= 0) {
          clearInterval(interval);
          that.time = 0;
          that.currentTime = 20;
        }
      }, 1000);
    },
    // 拨打客服电话
    makePhoneCall() {
      this.MakeCall(); //拨打电话
    },
    // 取消订单
    cancelOrder() {
      let _this = this;
      this.$dialog
        .confirm({
          message: "是否取消该订单？",
          confirmButtonText: "是的",
          cancelButtonText: "再想想",
        })
        .then(() => {
          // on confirm
          let data = {
            order_sn: this.order_sn,
          };
          _this.$post("/api/cancel_order", data, data).then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              _this.$notify({ type: "success", message: "取消成功！" });
              _this.$router.go(-1);
            } else {
              this.$notify({
                type: "danger",
                message: res.data.message || "稍后重试！",
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 支付下单
    goPayresult() {
      // console.log(this.details)
      let _this = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let param = {
        order_sn: this.order_sn,
        pay_type: "unionpay",
        wx_openid: Lockr.get("openId"), //微信openid
      };

      this.$post("/api/order_pay", param, param).then((res) => {
        // console.log(res);
        this.$toast.clear(); //关闭弹窗
        if (res.data.code == 0) {
          console.log(res.data.data, "订单支付");
          window.location.href = res.data.data.pay;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 删除
    delete_order() {
      let _this = this;
      let data = {
        order_sn: this.order_sn,
      };
      _this.$post("/api/del_order", data, data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          _this.$notify({ type: "success", message: "删除成功！" });
          _this.$router.go(-1);
        } else {
          this.$notify({
            type: "danger",
            message: res.data.message || "稍后重试！",
          });
        }
      });
    },
    // 跳物流
    goExpressPage(even) { 
      // let aaa = JSON.stringify(shipping)
      // console.log(aaa)
      // console.log(JSON.parse(aaa))

      this.$router.push({
        name: "order-express",
        query: {
          order_sn:even.order_sn,
          shipping: JSON.stringify(even.shipping)
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 0 0 50px;
  box-sizing: border-box;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  /* 顶部状态 */
  .header-block {
    text-align: left;
    height: 133px;
    width: 100%;
    background-color: #ff5000;
    background-image: url("../../assets/mine/h-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .header-tips {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 75px;
      width: 100%;
      // background-image: url("https://qiniu.zdyxjx.com/minizdyxdui.png");
      // background-repeat: no-repeat;
      // background-size: 130px 130px;
      // background-position: right -55px;
    }

    .header-tips-title {
      padding-left: 27px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 41px;
      color: #ffffff;
    }

    .header-tips-desc {
      padding-left: 27px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
    }
  }

  /* 收货地址 */
  .mation-block {
    text-align: left;
    height: 90px;
    background-color: #fff;
    margin: 15px 10px;
    padding: 0 10px;
    box-shadow: 0px 1.5px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .line {
      width: 1px;
      height: 48px;
      background-color: #cccccc;
    }

    .express-l {
      padding-top: 20px;
      width: 10px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 12px;
      color: #78849e;
      background-image: url("https://qiniu.zdyxjx.com/minizdyxexpress_icon.png");
      background-repeat: no-repeat;
      background-size: 10px 10px;
      background-position: 0 6px;
    }

    .address-l {
      padding-top: 20px;
      width: 10px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 12px;
      color: #78849e;
      background-image: url("../../assets/icon/map2.png");
      background-repeat: no-repeat;
      background-size: 10px 10px;
      background-position: 0 6px;
    }

    .mation-info {
      /* background-color: paleturquoise; */
      width: 300px;
    }

    .mation-name {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-name {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-time {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #666666;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .mation-address {
      width: 100%;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }
  }
}
//
/* 物流信息 */
.delivery-block {
  display: flex;
  justify-content: space-around;
  align-items: center;
  // height: 90px;
  margin: 0 10px;
  padding: 5px 10px;
  border-bottom: 1px solid #eeeeee;

  .delivery-line {
    width: 1px;
    height: 48px;
    background-color: #cccccc;
  }

  .delivery-express-l {
    padding-top: 20px;
    width: 10px;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 12px;
    color: #78849e;
    background-image: url("https://qiniu.zdyxjx.com/minizdyxexpress_icon.png");
    background-repeat: no-repeat;
    background-size: 10px 10px;
    background-position: 0 6px;
  }

  .delivery-info {
    /* background-color: paleturquoise; */
    width: 280px;
  }

  .delivery-name {
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }

  .delivery-time {
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }
}
// cell
.btb {
  // border-bottom: 1px solid #eeeeee;
  border-bottom: 1px dashed #eeeeee;
}
.total-block {
  padding: 5px 10px;
  margin: 0 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .total-left {
    width: 40%;
    text-align: right;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #454f63;
  }

  .total-right {
    // width: 45%;
    text-align: right;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #78849e;
  }

  .total-tips {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 17px;
    color: #999999;
  }

  .total-price {
    width: 30%;
    text-align: right;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 30px;
    color: #e95970;
  }
}

/* 订单详情 */
.order-detail {
  margin: 10px;
  padding: 10px 0;
  box-shadow: 0px 1.5px 4.5px rgba(69, 79, 99, 0.06);
  border-radius: 5px;
  background-color: #fff;
  text-align: left;

  .order-detail-tips {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    padding-left: 10px;
    border-left: 2.5px solid #ff5000;
  }
  .total_t {
    padding: 5px 10px;
    text-align: left;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #454f63;
    span {
      color: #3497fd;
    }
  }
}
/*商品详情*/
.goods-block {
  margin: 0 10px;
  background-color: #fff;
  box-shadow: 0px 2px 4.5px rgba(69, 79, 99, 0.06);
  border-radius: 5px;
  text-align: left;

  .order-info-block {
    padding: 10px 0;
    margin: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background-color: papayawhip;
  }

  .img {
    width: 145px;
    height: 145px;
  }

  .info-block {
    width: 200px;
  }

  .name {
    width: 100%;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #454f63;
    // white-space: nowrap;
    // /*内容超宽后禁止换行显示*/
    // overflow: hidden;
    // /*超出部分隐藏*/
    // text-overflow: ellipsis;
    // /*文字超出部分以省略号显示*/
  }

  .desc {
    width: 100%;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #78849e;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }

  .udc {
    display: inline-block;
    background: #f9f9f9;
    padding: 2px 5px;
    border-radius: 5px;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #bbbbbb;
  }

  .price-block {
    margin-top: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30pxpx;
    color: #78849e;
  }

  .price-tips {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #cccccc;
  }

  .price {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #78849e;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .num {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #cccccc;
  }
}

/* 底部按钮 */
.foot-order-btn-block {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eee;

  box-shadow: 0px 2px 4.5px rgba(69, 79, 99, 0.06);
  /* background-color: paleturquoise; */
  background-color: #fff;
  display: flex;
  // flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;

  .btn {
    width: 90px;
    height: 25px;
    border: 1px solid #78849e;
    opacity: 1;
    border-radius: 14px;
    margin-right: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;

    color: #78849e;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btns {
    border: 1px solid #ff5000;
    color: #ff5000;
  }

  .btnf {
    border: 1px solid #ff5000;
    background-color: #ff5000;
    color: #fff;
  }

  .op {
    opacity: 0.5 !important;
  }
}

// 复制
.copy {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 17px;
  color: #00a8c0;
  margin: 0 10px;
}
.fz {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 17px;
  color: #e95970;
  margin-right: 10px;
}
.btn:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
